import React from 'react';
import { ITabControl } from './interfaces';
import { Box, Tabs } from '@mui/material';

export const TabControl: React.FC<ITabControl> = ({
  value,
  children,
  onChange,
}): JSX.Element => {
  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: '10px' }}>
      <Tabs
        value={value}
        onChange={(_, value) => onChange(value)}
        sx={{
          minHeight: 32,
        }}
      >
        {children}
      </Tabs>
    </Box>
  );
};
